import { render } from "./BaseTeamMember.vue?vue&type=template&id=70d2e3fd&scoped=true"
import script from "./BaseTeamMember.vue?vue&type=script&lang=js"
export * from "./BaseTeamMember.vue?vue&type=script&lang=js"

import "./BaseTeamMember.vue?vue&type=style&index=0&id=70d2e3fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d2e3fd"]])

export default __exports__